module.exports = __webpack_public_path__ + "img/zxjy.ffe6a0c8.png";